import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {I18nFormatter} from "../../utils/I18n/I18n";

const AggregationInfoChart = ({ item, init }) => {
    useEffect(() => {
        init();
    }, [init]);

    return (
        <div className="chart_container">
            <div className="chart">
                <span className="title">NGR:</span>
                <span className="value">{
                    (item && item.aggregationInfo && item.aggregationInfo.ngr)
                        ? I18nFormatter.currency(
                            item.aggregationInfo.ngr.amount,
                            item.aggregationInfo.ngr.currency
                          )
                        : '-'
                }</span>
            </div>
            <div className="chart">
                <span className="title">RS:</span>
                <span className="value">{
                    (item && item.aggregationInfo && item.aggregationInfo.rs)
                        ? I18nFormatter.currency(
                            item.aggregationInfo.rs.amount,
                            item.aggregationInfo.rs.currency
                          )
                        : '-'
                }</span>
            </div>
        </div>
    );
};

AggregationInfoChart.propTypes = {
    item: PropTypes.object,
    loading: PropTypes.bool,
    init: PropTypes.func
};

AggregationInfoChart.defaultProps = {
    item: null,
    loading: false,
    init: () => {}
};

export default AggregationInfoChart;
